import React from "react";
import Image from "../../assetes/Deluxe-4.webp";
import { MdOutlineLocationOn } from "react-icons/md";
import { LiaCalendarCheck } from "react-icons/lia";
import { MdOutlineWatchLater } from "react-icons/md";
import { LuUser } from "react-icons/lu";
import { PiFlowerLotus } from "react-icons/pi";

import Info from "./Info";
// دالة تنسيق التاريخ
const formatDate = (dateString) => {
  if (!dateString) return ""; // التحقق من أن التاريخ موجود
  const [year, month, day] = dateString.split("-");
  return `${day}.${month}.${year}`;
};
function InfoCard() {
  return (
    <div className="flex md:justify-between gap-[10px] items-start py-[16px] px-[24px] bg-white border border-[#919191] border-solid rounded-[11px] rtl"
>
      {/* <img className="w-[96px] h-[96px] object-cover rounded-md" src={Image} alt="image.webb" /> */}
      <div className="flex flex-col" style={{ display: "contents" }}>
        {/* <Info icon={<MdOutlineLocationOn />} text="Cologne Ehrenfeld" /> */}
        <Info 
  icon={<LiaCalendarCheck />} 
  text={formatDate(sessionStorage.getItem('date'))} 
/>        <Info icon={<MdOutlineWatchLater />} text={sessionStorage.getItem('selectedTime') + "-" + sessionStorage.getItem('endTime')} />
        <div className="flex gap-4">
          <Info icon={<LuUser />} text={sessionStorage.getItem('adults')} />
          {/* <div className="w-[2px] h-[24px] bg-[#919191]"></div> */}
          {/* <Info icon={<PiFlowerLotus />} text="Deluxe" /> */}
        </div>
      </div>
    </div>
  );
}

export default InfoCard;
